export class Authentication {
  constructor(
    public token: string = ""
  ) {}
}
